/**
 * Hash-части вкладок карточки команды.
 *
 * Живут в `domain` по той же причине, что и `ChampionshipEditTab`: hash — часть
 * роута (`Pages.TEAMS.builders.edit`). Подписи и порядок вкладок — в
 * `ui/components/team-view-tabs/constants.tsx`, где они привязаны к типу `Tab`
 * из `ud-ui`, которому в `domain` не место.
 */
export enum TeamViewTab {
  COMMON = 'common',
  PLAYERS = 'players',
  PARTICIPANTS = 'participants',
  WAITING_LIST = 'waiting-list',
  KITS = 'kits',
}
